import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import useStateHandler from '@/hooks/useStateHandler';
import useTranslations from '@/i18n/useTranslations';
import GalleryService from '@/services/gallery.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import ShippingNameInput from './ShippingNameInput';

import './styles/SaveShippingData.css';

function SaveShippingDataContent({ formState, close }) {
  const t = useTranslations('common.forms.add_artwork');
  const [shippingName, setShippingName] = useState("");
  const { state, stateHandler } = useStateHandler();

  function saveShippingData() {
    const newShippingData = {
      saved_shipping_name: shippingName,
      _id: uuidv4(),
      data: formState.artwork_shipping,
    };

    const newGalleryShippings = [...state.user_session.gallery_shippings, newShippingData];

    stateHandler.set("user_session.gallery_shippings", newGalleryShippings);
    GalleryService.updateGalleryShippings(newGalleryShippings);
    stateHandler.set("temporalPopup", { 
      text: t('shipping.saved_successfully'),
    });
    close();
  }

  return (
    <>
      <ShippingNameInput
        className="shipping-name-input--save"
        value={shippingName}
        onChange={(event) => setShippingName(event.target.value)}
        placeholder={t('shipping.save_rate_placeholder')}
      />

      <ContinueButton turnOff={shippingName === ""} onClick={saveShippingData}>
        {t('shipping.save')}
      </ContinueButton>
    </>
  );
}

export default function SaveShippingData({ formState }) {
  const t = useTranslations('common.forms.add_artwork');
  const [openSaveModal, setOpenSaveModal] = useState(false);

  return (
    <>
      <Text className="save-shipping-data-opener element-non-selectable" onClick={()=>setOpenSaveModal(true)}>
        {t('shipping.save_information')}
      </Text>

      <GenericPopup open={openSaveModal} className="save-shipping-data-popup" opacity>
        <div className="save-shipping-data-popup__header">
          <Text className="save-shipping-data-popup__header-text">
            {t('shipping.save_information')}
          </Text>
          <XIcon className="save-shipping-data-popup__close" onClick={()=>setOpenSaveModal(false)}/>
        </div>

        <Text className="save-shipping-data-popup__text">
          {t('shipping.save_information_description')}
        </Text>

        <SaveShippingDataContent formState={formState} close={()=>setOpenSaveModal(false)}/>
      </GenericPopup>
    </>
  );
}
